import { combineReducers } from "redux";
import aiConfigurations from "./AiConfigurations/reducer";
import credits from "./Credits/reducer";
import reviewsRewriteWithAi from "./ReviewsRewriteWithAi/reducer";
import goalsCreateWithNovaAI from "./GoalsCreateWithNovaAI/reducer";

const aiFeatures = combineReducers({
  credits,
  aiConfigurations,
  reviewsRewriteWithAi,
  goalsCreateWithNovaAI,
});

export default aiFeatures;
